import { Typography } from '@mui/material';
import React, { FC } from 'react';
import classNames from 'classnames';
import { DeepRequired, FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';
import { useStyles } from './ErrorMessage.styles';

interface ErrorMessageProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: string | Merge<FieldError, FieldErrorsImpl<DeepRequired<any>>> | undefined;
  withSidePadding?: boolean;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ error, withSidePadding = true }) => {
  const { classes } = useStyles();

  if (!error) {
    return null;
  }

  return (
    <Typography
      className={classNames(classes.root, 'font14', 'font-normal', 'd-inline-block', {
        [classes.sidePadding]: withSidePadding,
      })}
    >
      {error}
    </Typography>
  );
};
